import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MenuPopoverComponent } from './menu-popover.component';


@NgModule({
  declarations: [
    MenuPopoverComponent
  ],
  imports: [
      IonicModule,
      CommonModule,
      RouterModule,
      NgxDatatableModule
  ],
  exports: [
    MenuPopoverComponent
  ]
})
export class MenuPopoverModule {}